import { render, staticRenderFns } from "./organizer.vue?vue&type=template&id=525d6862&scoped=true"
import script from "./organizer.vue?vue&type=script&lang=js"
export * from "./organizer.vue?vue&type=script&lang=js"
import style0 from "./organizer.vue?vue&type=style&index=0&id=525d6862&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d6862",
  null
  
)

export default component.exports